module.exports = __webpack_public_path__ + "static/media/altitude.ad15d468.svg";